import { schema } from 'normalizr';

const country = new schema.Entity('countries');
const season = new schema.Entity('seasons');
const leagueSection = new schema.Entity('leagueSections');
const league = new schema.Entity('leagues');
const team = new schema.Entity('teams');
const playerPosition = new schema.Entity('playerPositions');
const player = new schema.Entity('players');
const scoutReportPlayer = new schema.Entity('scoutReportPlayers');
const scoutReport = new schema.Entity('scoutReports');

league.define({
  country,
  section: leagueSection
});

team.define({
  country
});

player.define({
  mainNationality: country,
  position: playerPosition
});

scoutReportPlayer.define({
  player
})

scoutReport.define({
  season,
  league,
  team,
  players: [ scoutReportPlayer ]
});

const schemas = {
  SEASON: season,
  SEASON_ARRAY: [ season ],
  LEAGUE: league,
  LEAGUE_ARRAY: [ league ],
  TEAM: team,
  TEAM_ARRAY: [ team ],
  PLAYER: player,
  PLAYER_ARRAY: [ player ],
  SCOUT_REPORT: scoutReport
};

export default schemas;



// WEBPACK FOOTER //
// ./src/core/schemas/schemas.js